import baseAPI from '@/http'

const router = 'api/Pacote'

export const pacoteAPI = {
  create: (pacote) => baseAPI.post(router, pacote),
  update: (pacote) => baseAPI.put(router, pacote),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`)
}
